
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 900 600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#078930","d":"M0 0h900v600z"}}),_c('path',{attrs:{"fill":"#FCDD09","d":"M0 0l900 600H0z"}}),_c('path',{attrs:{"fill":"#DA121A","d":"M450 200l58.779 180.902-153.885-111.804h190.212L391.22 380.902z"}})])
          )
        }
      }
    